import type { Testimonio } from '../types/content'

export const testimoniosDestacados: Testimonio[] = [
  {
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Córdoba',
    product: 'MegaPack Cocina Proteica',
    quote:
      'Organicé toda mi semana proteica en una tarde. Las listas de compras me ahorran horas. Ya no improviso más la cena.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    product: 'MegaPack Cocina Proteica',
    quote:
      'El Tomo de Viandas me cambió la vida laboral. Llevo tupper todos los días y gasté la mitad en comida este mes.',
  },
  {
    initials: 'RM',
    name: 'Romina M.',
    location: 'Buenos Aires',
    product: 'MegaPack Cocina Proteica',
    quote:
      'Mis domingos dejaron de ser un caos. El sistema de 2 horas es un antes y un después en casa.',
  },
]

export const testimonios: Testimonio[] = [
  {
    initials: 'DM',
    name: 'Daniela M.',
    location: 'Córdoba',
    product: 'MegaPack Cocina Proteica',
    quote:
      'El Tomo de Viandas Anti-Fracaso me cambió la vida. Ahora mis compañeros me preguntan qué como todos los días. Antes pedía delivery tres veces por semana.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'La Plata',
    product: 'MegaPack + El Método 80/20',
    quote:
      'Con la lista smart bajé un 40% lo que gastaba en comida. Los bonos solos ya valen el precio del pack entero.',
  },
  {
    initials: 'PA',
    name: 'Paula A.',
    location: 'Neuquén',
    product: 'MegaPack + El Método 80/20',
    quote:
      'El protocolo de 30 días del Método 80/20 me cambió los hábitos completamente. Ya no pienso más en qué como — el sistema piensa por mí.',
  },
  {
    initials: 'VL',
    name: 'Valentina L.',
    location: 'Rosario',
    product: 'MegaPack Cocina Proteica',
    quote:
      'Los domingos ahora los disfruto. En 2 horas tengo todo listo y el resto de la semana siento que tengo el control total de lo que como.',
  },
  {
    initials: 'NR',
    name: 'Natalia R.',
    location: 'Buenos Aires',
    product: 'MegaPack + El Método 80/20',
    quote:
      'Lo compré un domingo a las 10 de la mañana. A las 12 ya tenía la heladera organizada y la proteína de la semana lista. No lo podía creer.',
  },
]
